import CityPage from "../CityPage";

export default function Darien() {
  return <CityPage slug="darien" />;
}
